"use client";

import React from "react";
import { Shield, Info } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const privacyFeatures = [{
  title: "Secure Transition of Information",
  description: "When law enforcement officers or citizens submit welfare check details through our portal, all data is immediately secured within our system. We ensure a seamless, protected handoff from emergency services to our compassionate care network, guaranteeing that sensitive details are only accessible to authorized foundation personnel coordinating aid.",
  icon: Shield
}, {
  title: "Ethical Record-Keeping",
  description: "All submitted information—including names, addresses, and specific needs—is maintained in strict confidence. Our record-keeping practices are designed to protect the dignity of every senior we serve. Data is utilized exclusively to match seniors with appropriate volunteer companions and community services to facilitate necessary spiritual and basic needs support.",
  icon: Info
}];
export default function OurCommitmentToPrivacy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-commitment-to-privacy" className="bg-background py-12 md:py-24">
      <div ref={ref} className={`container mx-auto max-w-5xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24">
          <h2 className="font-serif text-xl md:text-3xl font-medium text-primary mb-6 tracking-tight">
            Our Commitment to Privacy
          </h2>
          <p className="text-base md:text-lg font-sans text-foreground leading-relaxed">
            We understand the sensitive nature of the information provided by law
            enforcement and the public. The St. Sampson Senior Aid Foundation is
            dedicated to handling all senior aid requests with the utmost
            confidentiality, respect, and ethical care.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-16">
          {privacyFeatures.map((feature, i) => {
          const Icon = feature.icon;
          return <Card key={i} data-index={i} className="card h-full flex flex-col transition-shadow duration-300">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-full bg-secondary/10 flex items-center justify-center mb-6">
                    <Icon className="w-6 h-6 text-secondary" aria-hidden="true" />
                  </div>
                  <CardTitle className="font-serif text-lg md:text-2xl font-medium text-primary">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow">
                  <CardDescription className="text-base md:text-lg font-sans text-foreground leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}